import { TableRow } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import styled from 'styled-components';

interface IRowTextProps {
  color?: string;
  align?: string;
}

interface ITableTitleRow {
  props?: {
    backgroundColor?: string;
    height?: string;
  };
}

interface ITitleTable {
  color?: string;
  align?: string;
}

interface ISubtitleTable {
  color?: string;
}

export const TitleTable = styled.b`
  text-align: ${(props: ITitleTable) => props.align || 'center'};
  color: ${(props: ITitleTable) => props.color || 'black'};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
`;

export const SubtitleTable = styled.b`
  color: ${(props: ISubtitleTable) => props.color || 'black'};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const DivRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const MyTableRow = styled(TableRow)`
  height: 5rem;
`;

export const RowText = styled.b<IRowTextProps>`
  text-align: ${(props) => props.align || 'center'};
  color: ${(props) => props.color};
  font-weight: normal;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
`;

export const RowTextBold = styled.p<IRowTextProps>`
  text-align: ${(props) => props?.align || 'center'};
  color: ${(props) => props.color};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

export const MyTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 13,
    color: 'blue',
    backgroundColor:
      theme.title === 'dark'
        ? theme.colors?.gray02
        : theme.colors?.gray02 || 'transparent',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor:
      theme.title === 'dark'
        ? theme.colors?.gray01
        : theme.colors?.gray01 || 'transparent',
  },
}));

export const TableTitleRow = styled(TableRow)<ITableTitleRow>`
  background-color: ${(props) => props?.props?.backgroundColor || 'white'};
  height: ${(props) => props?.props?.height || '5rem'};
`;
